"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localizationJsonSchema = void 0;
var z = _interopRequireWildcard(require("zod"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * POEditor term key - only characters [a-zA-Z], numbers [0-9] and underscores [_] are allowed.
 */
const keySchema = z.string({
  errorMap: (issue, ctx) => {
    switch (issue.code) {
      case 'invalid_string':
        return {
          message: `Key '${ctx.data}' contains an invalid character. Only characters [a-zA-Z], numbers [0-9] and underscores [_] are allowed.`
        };
      default:
        return {
          message: `Value '${ctx.data}' is not a valid key. Only characters [a-zA-Z], numbers [0-9] and underscores [_] are allowed.`
        };
    }
  }
}).regex(/^\w+$/);

/**
 * POEditor term value - only string is allowed. Objects, arrays, numbers, booleans or null are not allowed.
 */
const valueSchema = z.string({
  errorMap: (issue, ctx) => {
    switch (issue.code) {
      case 'invalid_type':
        return {
          message: `Value '${ctx.data}' is not a valid string. Objects, arrays, numbers, booleans or null are not allowed.`
        };
      default:
        return {
          message: `Value '${ctx.data}' is not a valid string. Objects, arrays, numbers, booleans or null are not allowed.`
        };
    }
  }
});

/**
 * Validation schema for PO Editor localization JSON
 *
 * Term key - only characters [a-zA-Z], numbers [0-9] and underscores [_] are allowed.
 * Term value - only string is allowed. Objects, arrays, numbers, booleans or null are not allowed.
 */
const localizationJsonSchema = exports.localizationJsonSchema = z.record(keySchema, valueSchema);
//# sourceMappingURL=LocalizationJson.js.map